import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "etc-o",
  "use": "etc-o-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"etc-o\"><title>etc</title><path d=\"M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18.75A8.75,8.75,0,1,1,18.75,10,8.75,8.75,0,0,1,10,18.75Zm-5-10A1.25,1.25,0,1,0,6.25,10,1.25,1.25,0,0,0,5,8.75Zm5,0A1.25,1.25,0,1,0,11.25,10,1.25,1.25,0,0,0,10,8.75Zm5,0A1.25,1.25,0,1,0,16.25,10,1.25,1.25,0,0,0,15,8.75Z\" transform=\"translate(0 0)\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/etc-o.svg
// module id = ou0O
// module chunks = 264